import { TOYOTA_URL as API } from 'settings/api';
import { v1 as getId } from 'uuid';
import { getToken } from 'helpers/utility';

export const fetchFIAS = ({
  value, alias, dependencies = {},
}) => {
  const URI = `${API}/autocomplete/search`;

  const query = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Request-Id': getId(),
    },
    body: JSON.stringify({
      accessToken: getToken(),
      data: {
        value,
        alias,
        dependencies,
      },
    }),
  };

  return fetch(URI, query)
    .then((response) => response.json())
    .then((json) => json);
};

export default {
  fetchFIAS,
};
